import React, { Fragment } from 'react';
import { QuestionCard as QuestionCardType } from '../types';
interface QuestionCardProps {
  card: QuestionCardType;
}
export function QuestionCard({
  card
}: QuestionCardProps) {
  // Format question with breaks after dots
  const formatQuestion = (text: string) => {
    return text.split('. ').map((sentence, index, array) => <Fragment key={index} data-id="element-66">
        {sentence}
        {index < array.length - 1 ? '.' : ''}
        {index < array.length - 1 && <br data-id="element-67" />}
      </Fragment>);
  };
  return <div className="bg-white rounded-lg shadow-md p-6 mx-4 my-6" data-id="element-68">
      <div className="text-[12px] text-gray-700 mb-2" style={{
      fontFamily: "'Playwrite US Modern', cursive"
    }} data-id="element-69">
        {card.subject}
      </div>

      <div className="w-full h-[4px] bg-gray-300 rounded-full mb-4" data-id="element-70" />

      <div className="text-[12px] text-gray-900 leading-relaxed" style={{
      fontFamily: "'Playwrite US Modern', cursive"
    }} data-id="element-71">
        {formatQuestion(card.question)}
      </div>
    </div>;
}